import mainLogo from '../../images/Recol/recol_logo_main.webp';
import squareLogo from '../../images/Recol/recol_logo_square_small.png';
import bannerLogoWhite from '../../images/Recol/recreio_logo_square_white.png';
import banner01 from '../../images/Recol/recol_banner_01.jpg';
import banner02 from '../../images/Recol/recol_banner_02.jpg';
import banner03 from '../../images/Recol/recol_banner_03.jpg';
import car123 from '../../images/Recol/123_golf.jpg';
import box123 from '../../images/Recol/123_vw.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Recol',
    defaultStoreLink: 'pecas.recolveiculos.com.br',
    defaultContactEmail: 'atendimento@recolveiculos.com.br',
    whatsappNumber: '68 3211 6000',
    CNPJname: '',
    CNPJ: '',
    CNPJaddress: '',
    launchDate: '01/06/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        'volkswagen',
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "RECOL VEICULOS",
    ],

    disabledSellers: [],

    useMktNames: true,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.KitsDiscountValue
        },
        {
            name: 'Kits Óleos',
            img: 'tabOleos',
            products: SliderProducts.KitsOilDiscountValue
        },
        {
            name: 'Kits Correias',
            img: 'tabCorreias',
            products: SliderProducts.KitsChainDiscountValue
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.FiltrosDiscountValue
        },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.FreiosDiscountValue
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.AccessoriesDiscountValue
        },
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: bannerLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    bannerBrands: '',
    aboutUsBg: banner03,

    box123: box123,
    car123: car123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças originais <span style="font-weight: bold;">Volkswagen</span> direto da concessionária <span style="font-weight: bold;">Recol</span>.',
    aboutUs: {
        title: 'Sobre nós',
        content: [
            '...',
        ],
        link: 'https://www.recolveiculos.com.br/quem-somos',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/recolveiculos/',
        Facebook: 'https://www.facebook.com/Veiculosrecol',
        LinkedIn: 'https://br.linkedin.com/company/gruporecol',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}